var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_wrap"},[_c('div',{staticClass:"backgroud_bg"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../images/index/res-bg.png"),"alt":""}})]),_c('div',{staticClass:"bengin_act"},[_c('div',{staticClass:"bengin_btn"},[_vm._v(" 精彩活动,正在路上 ")])])])
}]

export { render, staticRenderFns }